import { render, staticRenderFns } from "./GiftCodeDetailPanel.vue?vue&type=template&id=1b1ef0d4&scoped=true&"
import script from "./GiftCodeDetailPanel.vue?vue&type=script&lang=js&"
export * from "./GiftCodeDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./GiftCodeDetailPanel.vue?vue&type=style&index=0&id=1b1ef0d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ef0d4",
  null
  
)

export default component.exports